import { useState } from 'react'

import useRedux from '../../../../hooks/useRedux'
import useTranslations from '../../../../hooks/useTranslations'
import ANTDButton from '../../../../shared/antd/ANTDButton'
import ANTDDivider from '../../../../shared/antd/ANTDDivider'
import ANTDInput from '../../../../shared/antd/ANTDInput'
import ANTDSelect from '../../../../shared/antd/ANTDSelect'
// import { vehicleSideBar } from '../../../inventory/viewVehicle.description'

const PartNameSelector = ({ onAddOpt, ...restProps }) => {
  const { t } = useTranslations()
  const { selector } = useRedux()
  const { partTypeOpt = [] } = selector(state => state?.jobs?.options)
  const [partOpt, setPartOpt] = useState(() => partTypeOpt)
  const [search, setSearch] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const onInputSearch = async e => {
    const { value } = e?.target
    setSearch(value)

    if (value) {
      setPartOpt(
        partTypeOpt.filter(({ key, name }) =>
          t(key || name)
            ?.toLowerCase()
            ?.startsWith(value?.toLowerCase()),
        ),
      )
    } else {
      setPartOpt(partTypeOpt)
    }
  }

  const handleAddNewItem = () => {
    setPartOpt(preOpt => [{ label: search, value: search }, ...preOpt])
    setIsOpen(false)
    setSearch('')
    onAddOpt && onAddOpt(search)
  }

  const onDropdownVisible = visible => setIsOpen(visible)

  return (
    <ANTDSelect
      {...restProps}
      open={isOpen}
      filterOption={false}
      options={partOpt.map(opt => ({
        label: t(opt?.key || opt?.name),
        value: t(opt?.key || opt?.name),
      }))}
      onDropdownVisibleChange={onDropdownVisible}
      dropdownRender={menu => (
        <>
          <div
            style={{
              padding: '5px 4px',
            }}
            className="d-flex"
          >
            <ANTDInput
              style={{ marginRight: '8px' }}
              placeholder={t('txt_SearchPartName')}
              value={search}
              onChange={onInputSearch}
              onKeyDown={e => e.stopPropagation()}
            />

            <ANTDButton
              type="primary"
              onClick={handleAddNewItem}
              disabled={true}
              // disabled={!search}
            >{`${t('btn_Add')} +`}</ANTDButton>
          </div>
          <ANTDDivider
            style={{
              margin: '8px 0',
            }}
          />
          {menu}
        </>
      )}
    />
  )
}

export default PartNameSelector
